import { Injectable } from '@angular/core';
import { Params } from '@angular/router';

export const defaultListingPageSize = 36;

@Injectable({
  providedIn: 'root',
})
export class ListingsQueryParamService {
  defaultPageNumber = 1;
  defaultPageSize = defaultListingPageSize;

  getPageNumber(queryString: string): number {
    const pageNumber = this.convertToNumber(
      queryString,
      'page',
      this.defaultPageNumber,
    );
    return pageNumber;
  }

  getPageSize(queryString: string): number {
    const pageSize = this.convertToNumber(
      queryString,
      'page_size',
      this.defaultPageSize,
    );
    return pageSize;
  }

  buildPaginationQueryParams(pageNumber: number, pageSize: number): Params {
    return {
      page: pageNumber,
      page_size: pageSize,
    };
  }

  hasDealerFilter(queryString: string): boolean {
    return this.hasQueryParam(queryString, 'dealer_id');
  }

  hasQueryParam(queryString: string, key: string): boolean {
    const params = new URLSearchParams(queryString);
    return params.has(key);
  }

  // read a query param like page or page_size and trys to convert it to a number
  convertToNumber(
    queryString: string,
    key: string,
    fallbackNumber: number,
  ): number {
    const params = new URLSearchParams(queryString);
    const value = params.get(key);
    const parsedValue = value ? parseInt(value, 10) : NaN;
    const number =
      Number.isFinite(parsedValue) && parsedValue > 0
        ? parsedValue
        : fallbackNumber;

    return number;
  }
}
